import IconButton from '@/global/components/Button/IconButton'
import { cn } from '@/lib/utils'
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView'
import { TreeItem } from '@mui/x-tree-view/TreeItem'
import { hasPermission } from 'hooks/useBackendMenu'
import { PencilIcon, Trash2Icon, UserRoundSearchIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { CentroCusto } from 'service/api'
import { INodeCentroCusto, mapearArvore } from './mapArvore'

export default function ArvoreCentroCusto({
    fetchedData,
    children,
}: {
    fetchedData?: CentroCusto[]
    children?: React.ReactNode
}) {
    const navigate = useNavigate()
    const data = mapearArvore(fetchedData)

    const montarArvore = (node: INodeCentroCusto) => (
        <TreeItem
            key={node.id}
            itemId={node.id.toString()}
            label={
                <div className="grid grid-cols-[1fr_auto_auto_auto] items-center">
                    <span className="text-base">
                        {node.codigo} – {node.nomeCentroCusto}
                    </span>
                    {hasPermission(['read', 'Funcionários'], () => (
                        <IconButton
                            title="Listar funcionários"
                            onClick={e => {
                                e.stopPropagation()
                                navigate(`${node.id}/funcionarios`)
                            }}
                            sx={{ mr: 1 }}
                        >
                            <UserRoundSearchIcon />
                        </IconButton>
                    ))}
                    {hasPermission(['update', 'CentrosDeCusto'], () => (
                        <IconButton
                            title="Editar"
                            onClick={e => {
                                e.stopPropagation()
                                navigate(`${node.id}/editar`)
                            }}
                            sx={{ mr: 1 }}
                        >
                            <PencilIcon />
                        </IconButton>
                    ))}
                    {hasPermission(['delete', 'CentrosDeCusto'], () => (
                        <IconButton
                            title="Excluir"
                            onClick={e => {
                                e.stopPropagation()
                                navigate(`${node.id}/excluir`)
                            }}
                            sx={{ mr: 1 }}
                        >
                            <Trash2Icon className="text-error" />
                        </IconButton>
                    ))}
                </div>
            }
        >
            {Array.isArray(node.children)
                ? node.children.map(montarArvore)
                : null}
        </TreeItem>
    )

    return (
        <div
            className={cn(
                'flex flex-col w-full overflow-hidden justify-between',
                'h-[calc(100%-5rem)] mb-2',
                'border rounded-sm',
            )}
        >
            <div className="h-fit">{children}</div>
            <div className="size-full overflow-y-auto py-1 mt-1">
                <SimpleTreeView>
                    {data?.length ? (
                        data.map(montarArvore)
                    ) : (
                        <span className="text-base block text-center mt-4 select-none opacity-50">
                            Nenhum resultado
                        </span>
                    )}
                </SimpleTreeView>
            </div>
        </div>
    )
}
